import React, { useState } from 'react';
import NewActionButton from '../../../components/ActionButtons/NewActionButton';
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from '../../../common/cssclasses';
import { useTranslate } from '../../../components/TranslationText';
import NetaqInput from '../../../components/NetaqInput';

export default function HorseMarketFilter({ submit = () => {}, initialValues = {} }) {
  const { translate } = useTranslate();
  const filters = {
    stallionName: initialValues?.stallionName || '',
    priceFrom: initialValues?.priceFrom ?? null,
    priceTo: initialValues?.priceTo ?? null,
  };
  const [searchForm, setSearchForm] = useState(filters);

  const handleSubmit = (e) => {
    e.preventDefault();
    submit(searchForm);
  };

  const handleReset = () => {
    setSearchForm(filters);
  };

  const handleChange = (event) => {
    setSearchForm({
      ...searchForm,
      [event.target.name]: event.target.value
    });
  };

  return (
    <form
      className={filterCard}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <h2 className={filterHeader}>{translate('web.advancedSearch', 'Advanced Search')}</h2>
      <div className="mb-form-group">
        <NetaqInput
          name={"stallionName"}
          label={translate("web.horseName", "Horse Name")}
          placeholder={translate("web.horseName", "Horse Name")}
          type={"text"}
          value={searchForm?.stallionName}
          onChange={handleChange}
        />
      </div>
      <div className="mb-form-group-last">
        <div className="row">
          <div className="col-6">
            <NetaqInput
              name={"priceFrom"}
              type={"number"}
              label={
                <>
                  {translate("web.price", "rank")} {translate("web.from", "From")}
                </>
              }
              placeholder={'1'}
              value={searchForm.priceFrom}
              onChange={handleChange}
            />
          </div>
          <div className="col-6">
            <NetaqInput
              name={"priceTo"}
              type={"number"}
              label={
                <>
                  {translate("web.price", "showRange")} {translate("web.to", "To")}
                </>
              }
              placeholder={'10'}
              onChange={handleChange}
              minValue={searchForm.priceFrom}
              value={searchForm.priceTo}
            />
          </div>
        </div>
      </div>

      <div className={filterButtonsContainer}>
        <div className={filterResetBtn}>
          <NewActionButton
            key={"reset"}
            isButton
            classNames="btn-outline-secondary"
            type={"reset"}
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            key={"submit"}
            isButton
            classNames="btn-danger"
            type={"submit"}
            text={translate('web.search', 'Search')}
          />
        </div>
      </div>
    </form>
  );
}
